/** Тексты пространства «review». Ключи именуются по смыслу, а не по месту. */
export const review = {
  /* ── Хаб очередей ───────────────────────────────────────────────────── */
  hub: {
    title: 'Задачи',
    noAccess:
      'Очереди разбирают модераторы анкет и квест-мастера. Если вы должны быть среди них, напишите администрации проекта.',
  },

  queue: {
    loading: 'Собираем очередь',

    /** Значок у первой заявки: сравнивать не с чем. */
    initial: 'первая',
    /** Подпись нажимаемой строки для скринридера. */
    open: 'Разобрать: {{title}}',

    changed_one: 'изменено {{count}} поле',
    changed_few: 'изменено {{count}} поля',
    changed_many: 'изменено {{count}} полей',

    filter: {
      kind: 'Тип',
      initial: 'Первичные',
      edits: 'Правки',
    },

    /* Питомцы и способности берут имя вкладки из common.section. */
    name: {
      form: 'Анкеты',
      item: 'Предметы',
      ability: 'Способности и дебафы',
      log: 'Журнал',
    },

    empty: {
      title: 'Очередь пуста',
      form: 'Ни одной анкеты не ждёт решения. Заявки встают сюда сами, как только игрок отправляет их на проверку.',
      item: 'Ни один предмет не ждёт решения.',
      pet: 'Ни один питомец не ждёт решения.',
      ability: 'Ни одной заявки на способность.',
    },
  },

  /* ── Разбор заявки: общее у всех четырёх экранов ─────────────────────── */
  claim: {
    loading: 'Ищем заявку в очереди',
    pending: 'на проверке',
    notFound: 'Заявки нет в очереди',
    noName: 'Имя ещё не опубликовано',

    sentBy: 'прислал',
    claimedBy: 'заявил',

    /** Шапки сравнения: с чем сверяют заявку и что в ней самой. */
    before: 'В одобренной версии',
    beforeVersion: 'В одобренной версии {{number}}',
    after: 'В заявке',

    changed_one: 'Что изменилось · {{count}} поле',
    changed_few: 'Что изменилось · {{count}} поля',
    changed_many: 'Что изменилось · {{count}} полей',

    same: 'Остальное без изменений',
    proposal: 'Что предлагают',

    showMore_one: 'Показать ещё {{count}} поле',
    showMore_few: 'Показать ещё {{count}} поля',
    showMore_many: 'Показать ещё {{count}} полей',
  },

  stale: {
    title: 'Заявка изменилась, обновите',
  },

  /* ── Блок решения ───────────────────────────────────────────────────── */
  decision: {
    title: 'Решение',

    approve: 'Одобрить',
    confirm: 'Подтвердить',
    accept: 'Принять',
    reject: 'Отклонить',

    comment: {
      label: 'Комментарий',
      placeholder: 'Что поправить. Без него нельзя отклонить',
    },

    readOnly: {
      title: 'Только чтение',
      text: 'У вашего аккаунта снято право записи, отправить решение не получится.',
    },
  },

  /* ── Диалоги общего набора ──────────────────────────────────────────── */
  dialog: {
    confirm: {
      error: 'Не получилось',
    },
  },

  /** Имя для показа, когда его в вайтлисте просто нет. */
  person: {
    id: 'id {{id}}',
  },

  /* ── Предмет ────────────────────────────────────────────────────────── */
  item: {
    title: 'Предмет',
    noAccess: 'Склад подтверждают квест-мастера и суперадмины.',
    notFound:
      'Версию уже разобрали, игрок её отозвал или предмет удалили. Вернитесь к очереди — там только то, что действительно ждёт решения.',
    initial: 'Первая заявка по предмету: на складе его ещё нет, сравнивать не с чем.',
    stale:
      'Игрок поправил предмет, пока вы его читали. Решение не отправлено — посмотрите текст заново.',
    approved: 'Предмет одобрен и виден на складе персонажа.',
    rejected: 'Правка отклонена. На складе осталась прошлая одобренная версия.',
  },

  /* ── Питомец ────────────────────────────────────────────────────────── */
  pet: {
    title: 'Питомец',
    noAccess: 'Питомцев подтверждают квест-мастера и суперадмины.',
    notFound:
      'Версию уже разобрали, игрок её отозвал или питомца убрали в архив. Вернитесь к очереди — там только то, что действительно ждёт решения.',
    initial: 'Первая заявка по питомцу: в карточке персонажа его ещё нет, сравнивать не с чем.',
    stale:
      'Игрок поправил питомца, пока вы его читали. Решение не отправлено — посмотрите текст заново.',
    approved: 'Питомец одобрен и виден в карточке персонажа.',
    rejected: 'Правка отклонена. В карточке осталась прошлая одобренная версия.',
    field: {
      photo: 'Фотография',
      passport: 'Паспорт',
    },
  },

  /* ── Способность ────────────────────────────────────────────────────── */
  ability: {
    title: 'Способность',
    noAccess: 'Способности подтверждают квест-мастера и суперадмины.',
    notFound:
      'Версию уже разобрали, игрок её отозвал или способность убрали в архив. Вернитесь к очереди — там только то, что действительно ждёт решения.',
    initial: 'Первая заявка: одобренной версии ещё нет, сравнивать не с чем.',
    stale:
      'Заявку поправили или разобрали, пока вы её читали. Решение не отправлено — посмотрите текст заново.',
    approved: 'Способность подтверждена и теперь действует.',
    rejected:
      'Заявка отклонена, комментарий ушёл игроку. Прошлая одобренная версия осталась как была.',
    /** Бессрочная и «до такого-то» — разные вещи, и в диффе это должно быть видно. */
    expiry: {
      never: 'Бессрочно',
      until: 'До {{date}}',
      label: 'Срок действия',
    },
    source: {
      label: 'Источник:',
      missing: 'Источник: ссылку не приложили',
    },
  },

  /* ── Анкета ─────────────────────────────────────────────────────────── */
  form: {
    noAccess: 'Анкеты разбирают модераторы анкет и суперадмины.',
    loading: 'Открываем заявку',
    notFound: 'Заявку не нашли: её уже разобрали или отозвали.',

    appearanceAlt: 'Внешность: {{name}}',
    initial: 'Первичная анкета: в реестре персонажа ещё нет, сравнивать не с чем — читаем целиком.',

    revision_one: '{{count}} правка после отправки',
    revision_few: '{{count}} правки после отправки',
    revision_many: '{{count}} правок после отправки',

    stale:
      'Игрок поправил заявку, пока вы её читали. Решение не отправлено — данные на экране уже перечитаны, посмотрите их заново.',

    decided: {
      title: 'Заявку уже разобрали',
      text: 'Текущий статус — «{{status}}». Решение принимать больше не нужно, поля ниже открыты только для чтения.',
    },

    approved: 'Анкета принята и опубликована. Общежитие: {{dorm}}, класс: {{studyClass}}.',
    rejected: 'Анкета отклонена, комментарий ушёл игроку.',

    fields: 'Поля анкеты',
    /** Анкету сравнивают с принятой версией, а не с «одобренной». */
    before: 'В принятой версии',

    dorm: {
      label: 'Общежитие',
      placeholder: 'Не выбрано',
    },

    studyClass: {
      tag: 'Класс {{value}}',
      label: 'Класс',
      placeholder: 'Не выбран',
    },

    comment: {},

    readOnly: 'У вашего аккаунта снято право записи, поэтому решение отправить не получится.',
  },
} as const;
